module.exports = "/images/story_profile_3.png?b50dd846ec8c87f27e243696a7808524";